import URLParamsMapper from 'components/data/URLParams/URLParamsMapper'
import {path} from 'ramda'
const getAnonymousId = (): string =>
  path(['params', 'anonymousId'], URLParamsMapper())

export default getAnonymousId
